import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetBlogPage } from "../api/requests/pages";
import { GetBlogPosts } from "../api/requests/blogPosts";
import { BlogPageType, Category } from "../models/blog";
import { BlogPost } from "../models/blog";
import { AnyObject } from "../models/generic";
import { GenerateSlug } from "../utils/slug";
import Blog from "../views/blog";

export const BLOG_POST_LIMIT = 9;

interface Props {
  data: BlogPageType;
  posts: {
    items: BlogPost[];
    total: number;
    limit: number;
    page: number;
    pages: number;
  }
}

function Index({ data, posts }: Props) {
  return <Blog data={data} posts={posts} />;
}

export async function getServerSideProps({ locale, query }: any) {
  const pageData = await GetBlogPage();

  const filters: AnyObject = {};

  if(query.category && pageData?.data?.categories?.length > 0) {
    const found = pageData.data.categories.find((elem: Category) => GenerateSlug(elem.name[locale]) === query.category);
    if(found) filters.category = found._id;
  }
 
  if(query.search) filters.search = query.search;

  const posts = await GetBlogPosts(1, BLOG_POST_LIMIT, JSON.stringify(filters));

  return {
    props: {
      ...(await serverSideTranslations(locale, ["translation"])),
      data: pageData?.success ? pageData.data : {},
      posts: posts?.success ? posts.data : {}
    },
  };
}

export default Index;
